/* eslint-disable no-undef */

/**
 * node v16.13.0
 * vue 2.x
 */
const Config = {
    appver: 'Eye0.260910_A',
    apiurl: 'https://swissflex.it/API_v4/ordini',
    // apiurl: 'https://www.xspand.it/demo/swissflex/API/ordini',
    erpurl: 'https://websrv.eyeconfort.it/2023Master/api',
    apikey: 'swf_Apikey_f74f4e7ccc004653d7c6c67448#aaf72-c9270c97-1b3cae9e@',

    /* carico variabili da public/env.js */
    puntiSblocco: puntiSblocco,
    puntiCostoRiparazione: puntiCostoRiparazione,
}
console.log('Config', Config, process.env, window.location.hostname)
// controllare anche main.js
export default Config
